var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSupportLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.892 24.91H6.109V5.09h14.645l3.138 3.284V24.91zM22.017 3H6.11A2.1 2.1 0 0 0 4 5.09v19.82A2.1 2.1 0 0 0 6.11 27h17.782A2.1 2.1 0 0 0 26 24.91V7.203L22.017 3zm-6.671 19h-1.692c-.36 0-.654-.262-.654-.582v-6.729c-1.178-.525-1.994-1.68-2-3.193-.005-1.569.867-2.908 2.11-3.496v3.9h2.782V8c1.232.584 2.102 1.907 2.108 3.463.006 1.524-.813 2.692-2 3.222v6.732c0 .32-.294.582-.654.582z",
    fill: "url(#yzr3njkvaa)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yzr3njkvaa",
    x1: 4.316,
    y1: 3.69,
    x2: 4.316,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109BAC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSupportLight);
export default __webpack_public_path__ + "static/media/ic-support-light.7ddb9d4ff87c2b50e209afb1ecfd0bc8.svg";
export { ForwardRef as ReactComponent };